import { render, staticRenderFns } from "./Login - 副本 (3).vue?vue&type=template&id=050a3f3a&scoped=true"
import script from "./Login - 副本 (3).vue?vue&type=script&lang=js"
export * from "./Login - 副本 (3).vue?vue&type=script&lang=js"
import style0 from "./Login - 副本 (3).vue?vue&type=style&index=0&id=050a3f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a3f3a",
  null
  
)

export default component.exports